// Site-wide SEO constants. REACT_APP_SITE_URL is the canonical origin.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://ratecurrent.com").replace(/\/+$/, "");
export const SITE_NAME = "RateCurrent";

// Fail-safe default is NOINDEX. Indexing is switched on only at the launch gate
// (REACT_APP_ALLOW_INDEXING=true), so a dark-launch or preview deploy can never be indexed.
export const ALLOW_INDEXING = process.env.REACT_APP_ALLOW_INDEXING === "true";

// HOOK (SEO spec 3.2 / T4): site-relative path of the 1200x630 Open Graph image, e.g. "/og/default.png".
// The asset does not exist yet (Ive-WBD / Martha-BRM). While null, no og:image / twitter:image tag is emitted,
// so no tag ever points at a 404. Set it here (or via REACT_APP_OG_IMAGE_PATH) once the file ships.
export const OG_IMAGE_PATH = process.env.REACT_APP_OG_IMAGE_PATH || null;
export const OG_IMAGE_ALT = "RateCurrent: Texas ESID lookup and electric bill explainer";

/** Site-relative path to the canonical form used everywhere (no trailing slash; "/" stays "/"). */
export function normalizePath(path = "/") {
  const p = String(path).replace(/\/+$/, "");
  return p === "" ? "/" : p;
}
